import React from 'react';
import { Link, NavLink, LinkProps, NavLinkProps } from 'react-router-dom';

interface SafeLinkProps extends Omit<LinkProps, 'onClick'> {
    isBlocked?: boolean;
    onBlockedNavigation?: () => void;
    children: React.ReactNode;
}

interface SafeNavLinkProps extends Omit<NavLinkProps, 'onClick'> {
    isBlocked?: boolean;
    onBlockedNavigation?: () => void;
    children: React.ReactNode;
}

export const SafeLink: React.FC<SafeLinkProps> = ({ 
    isBlocked = false, 
    onBlockedNavigation, 
    children, 
    to,
    ...props 
}) => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (isBlocked) {
            const currentPath = window.location.pathname;
            const targetPath = typeof to === 'string' ? to : '';
            
            // Check if it's a child route navigation (should be allowed)
            const isChildRoute = targetPath.startsWith(currentPath + '/') || 
                               (currentPath.endsWith('/') && targetPath.startsWith(currentPath));
            
            // Allow child route navigation
            if (isChildRoute) {
                return; // Allow the navigation to proceed
            }
            
            event.preventDefault();
            event.stopPropagation();
            
            if (onBlockedNavigation) {
                onBlockedNavigation();
            }
            return false;
        }
    };

    return (
        <Link to={to} {...props} onClick={handleClick}>
            {children}
        </Link>
    );
};

export const SafeNavLink: React.FC<SafeNavLinkProps> = ({ 
    isBlocked = false, 
    onBlockedNavigation, 
    children, 
    to,
    ...props 
}) => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (isBlocked) {
            const currentPath = window.location.pathname;
            const targetPath = typeof to === 'string' ? to : '';
            
            // Check if it's a child route navigation (should be allowed)
            const isChildRoute = targetPath.startsWith(currentPath + '/') || 
                               (currentPath.endsWith('/') && targetPath.startsWith(currentPath));
            
            // Allow child route navigation
            if (isChildRoute) {
                return; // Allow the navigation to proceed
            }
            
            event.preventDefault();
            event.stopPropagation();
            
            if (onBlockedNavigation) {
                onBlockedNavigation();
            }
            return false;
        }
    };

    return (
        <NavLink to={to} {...props} onClick={handleClick}>
            {children}
        </NavLink>
    );
}; 